<template>
    <ToggleButton :value="isEnabled"
                  :sync="true"
                  :labels="{ checked: 'On', unchecked: 'Off' }"
                  @change="$emit('on-toggle', isEnabled)" />
</template>

<script>
    import { ToggleButton } from 'vue-js-toggle-button'

    export default {
        name: 'ToggleSwitch',
        props: {
            isEnabled: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            ToggleButton,
        },
    }
</script>